import { memo, type ReactNode, useMemo } from 'react';

import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { PrivateWorkspaceAgentPillClipsProvider } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPillClipsProvider';
import { type WorkspaceAgentTableRow } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/workspaceAgentTableArtifact';
import { collectWorkspaceAgentTablePagePills } from '~/components/v2/components/workspace/workspace-agent-panel/utils/collectWorkspaceAgentTablePagePills';

export type PrivateWorkspaceAgentTableMonikerFrameProps = {
  children: ReactNode;
  visibleRows: readonly WorkspaceAgentTableRow[];
};

/**
 * Clip lookup for the rows on screen. Nested under the thread provider so paging a table does not
 * widen the chat batch. Skill instructions use the same provider the same way.
 */
export const PrivateWorkspaceAgentTableMonikerFrame = memo(
  ({ children, visibleRows }: PrivateWorkspaceAgentTableMonikerFrameProps) => {
    const { workspaceId } = usePrivateWorkspaceAgentPanelSession();
    const pills = useMemo(() => collectWorkspaceAgentTablePagePills(visibleRows), [visibleRows]);

    if (!workspaceId) {
      return <>{children}</>;
    }

    return (
      <PrivateWorkspaceAgentPillClipsProvider pills={pills} workspaceId={workspaceId}>
        {children}
      </PrivateWorkspaceAgentPillClipsProvider>
    );
  },
);

PrivateWorkspaceAgentTableMonikerFrame.displayName = 'PrivateWorkspaceAgentTableMonikerFrame';
